import React from 'react';
import '../styles/Skills.css';
import {
  FaNetworkWired,
  FaShieldAlt,
  FaTools,
  FaCodeBranch,
  FaTerminal
} from 'react-icons/fa';
import {
  SiPaloaltonetworks,
  SiFortinet,
  SiCisco,
  SiAnsible,
  SiGit,
  SiPython,
  SiF5,
  SiCitrix,
  SiUbiquiti,
  SiDocker,
  SiLinux
} from 'react-icons/si';

const skills = [
  { icon: <SiPaloaltonetworks />, label: 'Palo Alto NGFW' },
  { icon: <SiFortinet />, label: 'Fortinet Firewalls' },
  { icon: <SiCisco />, label: 'Cisco Networking' },
  { icon: <SiF5 />, label: 'F5 LTM' },
  { icon: <SiCitrix />, label: 'Citrix ADC' },
  { icon: <SiAnsible />, label: 'Ansible Automation' },
  { icon: <SiDocker />, label: 'Docker & Docker Compose' },
  { icon: <SiLinux />, label: 'Linux' },
  { icon: <SiUbiquiti />, label: 'Ubiquiti' },
  { icon: <FaNetworkWired />, label: 'Network Design' },
  { icon: <FaShieldAlt />, label: 'Firewall Hardening' },
  { icon: <SiPython />, label: 'Python Scripting' },
  { icon: <SiGit />, label: 'Git & GitOps' },
  { icon: <FaTerminal />, label: 'CLI & API Config' },
  { icon: <FaTools />, label: 'Wireshark & Tools' },
  { icon: <FaCodeBranch />, label: 'VPN & Segmentation' }

];

function Skills() {
  return (
    <section className="skills" id="skills">
      <h2>Skills & Tools</h2>
      <div className="skills-grid">
        {skills.map((s, index) => (
          <div className="skill" key={index}>
            {s.icon}
            <span>{s.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
